module.exports = __webpack_public_path__ + "img/finance1.ecfbf0cf.png";